/* eslint-disable no-unused-vars */
import React,
{
  useState,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import {
  useQuery,
} from '@apollo/client';
import _ from 'lodash';
import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Loader,
  Text,
  Popup,
  ContainerTrigger,
  Icon,
} from './styles';

import {
  TIMEZONES_LIST,
  TIMEZONE_NAME,
} from './graphql';

import Content from './content';

const TimezoneDropdown = (props) => {
  const {
    onChange,
    timeZone,
    toggleTime,
    onChangeToggle,
    onSetTimezoneName,
  } = props;

  const [searchTerm, setSearchTerm] = useState(null);

  /** queries */
  // Used to get the remapped timezone name
  const {
    data: timezoneData = {},
  } = useQuery(TIMEZONE_NAME, {
    variables: {
      unix: timeZone,
    },
    skip: !timeZone,
  });

  const {
    error,
    data = {},
    loading,
  } = useQuery(TIMEZONES_LIST);

  const { timezoneName = '' } = timezoneData;

  const { timezonesList = [] } = data || {};

  const groupedTimezones = useMemo(() => _.chain(timezonesList)
    .filter((t) => t.keep)
    .filter((v) => {
      if (!searchTerm) return true;
      return v.label.toLowerCase().replace(/(_|\/)/g, ' ')
        .includes(searchTerm.toLowerCase().replace(/(_|\/)/g, ' '));
    })
    .groupBy('group')
    .value(), [searchTerm, timezonesList]);

  const handleSelectedOption = useCallback((valueTimezone) => {
    onChange(valueTimezone);
  }, [onChange]);

  const handleFilterSearch = useCallback((inputFilter) => {
    setSearchTerm(inputFilter);
  }, []);

  const handleChangeToogle = () => {
    onChangeToggle(!toggleTime);
  };

  useEffect(() => {
    onSetTimezoneName(timezoneName);
  }, [onSetTimezoneName, timezoneName]);

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving timezone list."
      />
    );
  }

  if (loading) return <Loader data-loader="timezone-loader" />;

  return (
    <Popup
      onClose={() => { setSearchTerm(undefined); }}
      position="bottom right"
      basic
      pinned
      on="click"
      keepInViewPort={false}
      trigger={(
        <ContainerTrigger
          tabIndex="0"
          aria-label={`Timezone currently selected ${timezoneName}`}
          role="menu"
        >
          <Text bold>{timezoneName}</Text>
          <Icon name="caret down" />
        </ContainerTrigger>
      )}
      content={(
        <Content
          options={groupedTimezones}
          onSelectedOption={handleSelectedOption}
          onSearch={handleFilterSearch}
          itemSelected={timeZone}
          onChangeToggle={handleChangeToogle}
          toggleTime={toggleTime}
        />
      )}
    />
  );
};

TimezoneDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  onChangeToggle: PropTypes.func.isRequired,
  timeZone: PropTypes.string.isRequired,
  toggleTime: PropTypes.bool.isRequired,
  onSetTimezoneName: PropTypes.func,
};

TimezoneDropdown.defaultProps = {
  onSetTimezoneName: () => {},
};

export default TimezoneDropdown;
